import DeliveriesRoute from 'cio/routes/base-deliveries';

export default class IndexRoute extends DeliveriesRoute {
  setDefaultTimeRange = false;

  model() {
    return this.modelFor('broadcasts.broadcast.overview.broadcasts.trigger');
  }

  setupController(controller, model) {
    controller.setProperties({
      broadcastTrigger: model.get('id'),
      campaign: model.belongsTo('campaign').id(),
    });

    super.setupController(...arguments);
  }
}
